import { computed } from "vue";
import { useIsMobile } from "@/composables/useIsMobile";

// Utility function to adjust zoom and center for mobile devices and individual routes
function adjustForMobile(layers) {
  const { isMobile } = useIsMobile();
  console.log("Is Mobile:", isMobile.value);
  return layers.map((layer) => {
    // Apply adjustments only if it's a mobile device
    if (isMobile.value) {
      return {
        ...layer,
        zoom: layer.zoom + (layer.zoomAdjustment || 0), // Apply zoomAdjustment for mobile
        center: [
          layer.center[0] + (layer.centerAdjustment?.[0] || 0), // Apply centerAdjustment for mobile
          layer.center[1] + (layer.centerAdjustment?.[1] || 0),
        ],
      };
    }

    // For desktop, return the original zoom and center without adjustments
    return {
      ...layer,
      zoom: layer.zoom, // No adjustment for desktop
      center: layer.center, // No adjustment for desktop
    };
  });
}
// GeoJSON layers with individual adjustments
const baseGeojsonLayers = [
  {
    id: "0",
    title: "Tour du Mont Blanc",
    trekLocation: "Europe",
    route: "Full Route",
    type: "line",
    url: "/tour-du-mont-blanc",
    sourceUrl: "/geojson/tmb.geojson",
    poster: "/images/maps/tmb-full.jpg",
    center: [6.9, 45.91],
    zoom: 9.5,
    zoomAdjustment: -2,
    centerAdjustment: [0, 0],
    initialPitch: 46.5,
    initialBearing: -8,
    initialZoom: 9.5,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 6,
    },
  },
  {
    id: "1",
    title: "Tour du Mont Blanc",
    route: "Easterly Route",
    trekLocation: "Europe",
    type: "line",
    url: "/tour-du-mont-blanc",
    sourceUrl: "/geojson/tmb-east.geojson",
    poster: "/images/maps/tmb-east.jpg",
    center: [6.9, 45.91],
    zoom: 11,
    zoomAdjustment: 0,
    centerAdjustment: [0, -0.05],
    initialPitch: 44,
    initialBearing: 0,
    initialZoom: 10.1,
    initialZoomMobile: 9,
    paint: {
      "line-color": "#FF5733",
      "line-width": 6,
    },
  },
  {
    id: "2",
    title: "Tour du Mont Blanc",
    route: "Westerly Route",
    trekLocation: "Europe",
    type: "line",
    url: "/tour-du-mont-blanc",
    sourceUrl: "/geojson/tmb-west.geojson",
    poster: "/images/maps/tmb-west.jpg",
    center: [6.9, 45.91],
    zoom: 10,
    zoomAdjustment: -1.5,
    centerAdjustment: [0, -0.05],
    initialPitch: 44,
    initialBearing: 0,
    initialZoom: 10.1,
    initialZoomMobile: 9,
    paint: {
      "line-color": "#FF5733",
      "line-width": 6,
    },
  },
  {
    id: "3",
    title: "Walker's Haute Route",
    route: "Full Route",
    trekLocation: "Europe",
    type: "line",
    url: "/walkers-haute-route",
    sourceUrl: "/geojson/whr.geojson",
    poster: "/images/maps/whr-full.jpg",
    center: [7.4, 46.023],
    zoom: 9,
    zoomAdjustment: -1.5,
    centerAdjustment: [-0.03, -0.01],
    initialPitch: 45,
    initialBearing: 0,
    initialZoom: 9.5,
    initialZoomMobile: 7,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },

  {
    id: "4",
    title: "Walker's Haute Route",
    route: "Westerly Route",
    trekLocation: "Europe",
    type: "line",
    url: "/walkers-haute-route",
    sourceUrl: "/geojson/whr-west-new.geojson",
    poster: "/images/maps/whr-west.jpg",
    center: [7.531568528594565, 46.06782745326259],
    zoom: 10,
    zoomAdjustment: 0,
    centerAdjustment: [-0.25, 0],
    initialPitch: 45,
    initialBearing: 0,
    initialZoom: 9.5,
    initialZoomMobile: 8,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "5",
    title: "Walker's Haute Route",
    route: "Easterly Route",
    trekLocation: "Europe",
    type: "line",
    url: "/walkers-haute-route",
    sourceUrl: "/geojson/whr-east-new.geojson",
    poster: "/images/maps/whr-east.jpg",
    center: [7.388610400345603, 46.07731319355546],
    zoom: 10,
    zoomAdjustment: 0,
    centerAdjustment: [0.25, 0],
    initialPitch: 45,
    initialBearing: 0,
    initialZoom: 9.5,
    initialZoomMobile: 7.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "6",
    title: "Tour of the Monte Rosa",
    route: "Full Route",
    trekLocation: "Europe",
    type: "line",
    url: "/tour-of-the-monte-rosa",
    sourceUrl: "/geojson/tmr.geojson",
    poster: "/images/maps/tmr-full.jpg",
    center: [7.8, 46.0255],
    zoom: 10,
    zoomAdjustment: -1,
    centerAdjustment: [0, 0],
    initialPitch: 50,
    initialBearing: 0,
    initialZoom: 9.5,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "7",
    title: "Tour of the Jungfrau",
    route: "Full Route",
    trekLocation: "Europe",
    type: "line",
    url: "/tour-of-the-jungfrau",
    sourceUrl: "/geojson/jungfrau.geojson",
    poster: "/images/maps/jungfrau-full.jpg",
    center: [7.95, 46.6],
    zoom: 10.5,
    zoomAdjustment: -1,
    centerAdjustment: [-0.03, 0],
    initialPitch: 54.1,
    initialBearing: 133.4,
    initialZoom: 10.8,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "8",
    title: "The Italian Dolomites",
    route: "Full Route",
    trekLocation: "Europe",
    type: "line",
    url: "/the-italian-dolomites",
    sourceUrl: "/geojson/altavia1.geojson",
    poster: "/images/maps/altavia1-full.jpg",
    center: [12.15, 46.4],
    zoom: 9.5,
    zoomAdjustment: -1,
    centerAdjustment: [0, 0.06],
    initialPitch: 43.5,
    initialBearing: -146.4,
    initialZoom: 9.8,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "9",
    title: "Tour of the Vanoise",
    route: "Full Route",
    trekLocation: "Europe",
    type: "line",
    url: "/tour-of-the-vanoise",
    sourceUrl: "/geojson/vanoise.geojson",
    poster: "/images/maps/vanoise-full.jpg",
    center: [6.75, 45.4],
    zoom: 11.4,
    zoomAdjustment: -1,
    centerAdjustment: [-0.02, 0.02],
    initialPitch: 46,
    initialBearing: 0,
    initialZoom: 11.6,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "10",
    title: "Traverse of the Gran Paradiso",
    route: "Full Route",
    trekLocation: "Europe",
    type: "line",
    url: "/traverse-of-the-gran-paradiso",
    sourceUrl: "/geojson/gran-paradiso.geojson",
    poster: "/images/maps/gran-paradiso-full.jpg",
    center: [7.2667, 45.6],
    zoom: 10,
    zoomAdjustment: -2,
    centerAdjustment: [0.02, 0],
    initialPitch: 47,
    initialBearing: 0,
    initialZoom: 10.3,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "11",
    title: "Annapurna Region",
    route: "Full Route",
    trekLocation: "Worldwide",
    type: "line",
    url: "/annapurna-region",
    sourceUrl: "/geojson/annapurna.geojson",
    poster: "/images/maps/annapurna-full.jpg",
    center: [84.0, 28.5],
    zoom: 9.2,
    zoomAdjustment: -1,
    centerAdjustment: [-0.1, -0.05],
    initialPitch: 58,
    initialBearing: 48.8,
    initialZoom: 10,
    initialZoomMobile: 8,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "12",
    title: "Mount Toubkal Trek",
    route: "Full Route",
    trekLocation: "Worldwide",
    type: "line",
    sourceUrl: "/geojson/atlas.geojson",
    poster: "/images/maps/atlas-full.jpg",
    center: [-7.9151, 31.15],
    zoom: 11,
    zoomAdjustment: -1,
    centerAdjustment: [0, -0.05],
    initialPitch: 50,
    initialBearing: 0,
    initialZoom: 11.2,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "13",
    title: "Patagonia Hiking",
    route: "Full Route",
    trekLocation: "Worldwide",
    type: "line",
    url: "/patagonia-hiking",
    sourceUrl: "/geojson/patagonia.geojson",
    poster: "/images/maps/patagonia-full.jpg",
    center: [-73.05, -50.96],
    zoom: 10,
    zoomAdjustment: -1,
    centerAdjustment: [0, 0],
    initialPitch: 53,
    initialBearing: 0,
    initialZoom: 10.4,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "14",
    title: "Salkantay and Inca Trail Peru",
    route: "Full Route",
    trekLocation: "Worldwide",
    type: "line",
    url: "/salkantay-and-inca-trail-peru",
    sourceUrl: "/geojson/peru.geojson",
    poster: "/images/maps/peru-full.jpg",
    center: [-72.57441, -13.3],
    zoom: 10.5,
    zoomAdjustment: 0,
    centerAdjustment: [0, -0.07],
    initialPitch: 40,
    initialBearing: -22,
    initialZoom: 11,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
  {
    id: "15",
    title: "Tour of the Jotunheimen",
    route: "Full Route",
    trekLocation: "Worldwide",
    type: "line",
    url: "/tour-of-the-jotunheimen",
    sourceUrl: "/geojson/norway.geojson",
    poster: "/images/maps/norway-full.jpg",
    center: [8.4, 61.55],
    zoom: 9,
    zoomAdjustment: -1,
    centerAdjustment: [0.1, 0],
    initialPitch: 49,
    initialBearing: 0,
    initialZoom: 10,
    initialZoomMobile: 8.5,
    paint: {
      "line-color": "#FF5733",
      "line-width": 5,
    },
  },
];

export const useFilteredGeojsonLayers = (trekLocation) => {
  return computed(() => {
    const adjustedLayers = adjustForMobile(baseGeojsonLayers);
    if (!trekLocation) return adjustedLayers;

    return adjustedLayers.filter(
      (layer) => layer.trekLocation === trekLocation,
    );
  });
};
